import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Container, Typography,
} from '@mui/material';
import GameModeCard from '../components/GameMode';

const GameModes = () => {
  const navigate = useNavigate();

  return (
    <Container id="game-modes-page" maxWidth="lg">
      <Typography variant="h1" gutterBottom>
        Game Modes
      </Typography>

      <Typography variant="h4" center>Game Modes</Typography>
      <Box id="game-modes-list" sx={{display:"flex", justifyContent:"center",borderRadius:2}}>
      <GameModeCard id="game-mode-time-trial" image="/pomo_clock.png" title="Time Trial" subtitle="Pomodoro Style Game Mode" onClick={() => navigate('/time-trial-settings')}></GameModeCard>
      </Box>
    </Container>
  );
};

export default GameModes;
